// ============================================================================
// vpn/vpnConfigFormat.ts — SSoT подписей и расширений файлов конфигурации VPN
// (формат приходит с сервера: ini|ovpn|mobileconfig|text|uri). Используется
// формой управления (VpnConfigBlock) и пользовательским экраном подключений
// (VpnConnectionDetails) — без дублирования таблиц форматов.
// ============================================================================

export const VPN_CONFIG_FORMAT_LABELS: Record<string, string> = {
  ini: 'WireGuard (.conf)',
  ovpn: 'OpenVPN (.ovpn)',
  mobileconfig: 'IKEv2 (.mobileconfig)',
  text: 'Текстовый файл',
  uri: 'Ссылка для приложения',
};

export const VPN_CONFIG_FORMAT_EXT: Record<string, string> = {
  ini: 'conf',
  ovpn: 'ovpn',
  mobileconfig: 'mobileconfig',
  text: 'txt',
  uri: 'txt',
};

/** Расширение файла конфигурации (неизвестный формат — txt). */
export function vpnConfigExt(format: string): string {
  return VPN_CONFIG_FORMAT_EXT[format] || 'txt';
}

/** Безопасное имя файла из названия подключения. */
export function vpnConfigFileName(name: string, format: string): string {
  const safe = name.replace(/[\\/:*?"<>|]+/g, '-').trim() || 'vpn';
  return `${safe}.${vpnConfigExt(format)}`;
}
